/* eslint-disable camelcase */
export default ({ data }) => {
  let cloud_settings = {
    cloud_storage_provider: null,
    file_picker_settings: {
      google_drive: {
        client_id: null,
        api_developer_key: null,
      },
      one_drive: {
        client_id: null,
      },
    },
  };

  if (data?.cloud_settings) {
    cloud_settings = {
      ...cloud_settings,
      ...data.cloud_settings,
    };
  }

  return cloud_settings;
};
